<template>
  <v-card :loading="showDialogProgress" :disabled="showDialogProgress">
    <div class="VacationRequest">
      <vacation-remain />
  
      <box class="" :title="this.$t('nav-request-leave')">
        <div class="px-3 pt-2">
          <v-form ref="form" v-model="form">
            <v-row>
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col class="max-width-text-title px-1 d-flex">
                    <label class="my-auto" for="vacationParams.vacationType">{{ $t("vacationType") }} :
                    </label>
                  </v-col>
                  <v-col>
                    <v-select :rules="[$rules.required]" hide-details v-model="vacationParams.vacationType"
                      :items="vacationTypes" :label="$t('vacationType')" item-text="Name" item-value="Code" return-object
                      dense solo v-on:change="changeVacationType" class="my-auto py-0"></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
  
            <v-row class="mt-2">
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col class="max-width-text-title px-1 d-flex">
                    <label class="my-auto">{{ $t("fromDate") }} : </label>
                  </v-col>
                  <v-col>
                    <dialog-date-picker :label="$t('fromDate') + ':'" :initDate="initBeginDate" @dateResult="bDate" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6">
                <v-row class="mt-2 mt-sm-0">
                  <v-col class="max-width-text-title px-1 d-flex">
                    <label class="my-auto">{{ $t("toDate") }} : </label>
                  </v-col>
                  <v-col>
                    <dialog-date-picker :label="$t('toDate') + ':'" :initDate="initEndDate" @dateResult="eDate" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
  
            <v-row class="mt-2" v-if="showVacationTime">
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col class="max-width-text-title px-1 d-flex">
                    <label class="my-auto">{{ $t("fromTime") }} : </label>
                  </v-col>
                  <v-col>
                    <dialog-time-picker :label="$t('fromTime') + ':'" :initTime="initBeginTime" @dateResult="bTime" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6">
                <v-row class="mt-2 mt-sm-0">
                  <v-col class="max-width-text-title px-1 d-flex">
                    <label class="my-auto">{{ $t("toTime") }} : </label>
                  </v-col>
                  <v-col>
                    <dialog-time-picker :label="$t('toTime') + ':'" :initTime="initEndTime" @dateResult="eTime" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
  
            <v-row class="mt-2">
              <v-col cols="12" sm="12">
                <v-row>
                  <v-col class="max-width-text-title px-1 d-flex">
                    <label class="my-auto">{{ $t("description") }} : </label>
                  </v-col>
                  <v-col>
                    <v-textarea solo dense hide-details="" ref="description" v-model="vacationParams.Description"
                      auto-grow :placeholder="$t('description')" rows="2"></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
  
          <v-card-actions class="px-0 pt-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="showWorkCalndar = !showWorkCalndar">{{
              $t("workCalendar")
            }}</v-btn>
            <v-btn color="primary" :disabled="!form" :loading="isLoading" @click="addVacation">{{
              $t("vacationRegistration")
            }}</v-btn>
            <v-btn color="primary" v-if="visibleBtn" :disabled="!form" :loading="isLoading" @click="showIntervalIo">{{
              $t("nav-interval-io")
            }}</v-btn>
          </v-card-actions>
        </div>
      </box>
      <IntervalIOList
      ref="intervalIOList"
      class="py-2"
      :visible="IntervalIOListVisibility"
    />
  
      <WorkCalendar :showWorkCalndar="showWorkCalndar" :perno="vacationDetails.PerNo" />
    </div>
  </v-card>
</template>

<script>
import IntervalIOList from "../../components/io/IntervalIO/IntervalIOList.vue";
import VacationRemain from "../../components/request/VacationRemain.vue";
import WorkCalendar from "../../components/request/WorkCalendar.vue";
import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
import DialogTimePicker from "../../components/widget/DialogTimePicker.vue";
import EosToastType from "../../model/EosToastType";
import DateUtils from "../../utils/DateUtils";
import TextUtils from "../../utils/TextUtils";

export default {
  components: {
    WorkCalendar,
    DialogDatePicker,
    VacationRemain,
    DialogTimePicker,
    IntervalIOList,
  },
  mounted() {
    this.getVacationTypes();
    this.checkDescriptionRules();
  },
  data() {
    return {
      args: {},
      vacationDetails: {},
      vacationParams: {},
      vacationTypes: [],
      showVacationTime: false,
      showWorkCalndar: false,
      showDialogProgress: false,
      form: false,
      isLoading: false,
      initBeginDate: null,
      beginDate: "",
      initEndDate: null,
      endDate: "",
      initBeginTime: "",
      initEndTime: "",
      beginTime: "",
      endTime: "",
      descriptionRules: "",
      visibleBtn:false,
      IntervalIOListVisibility:false,
    };
  },
  methods: {
    getArgs() {
      this.args = this.$route.params.vacationDetails;
      if (this.args) {
        this.loadVacationRegistration(this.args);
      }

      var selectedDate = this.$route.query.SD;
      if (selectedDate) {
        this.initBeginDate = this.beginDate = selectedDate;
        this.initEndDate = this.endDate = selectedDate;
      debugger
      }
    },
    loadVacationRegistration(args) {
      const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(args.PageNo));
      params.append("dbkind", args.DBKind);
      params.append("year", args.Year);
      params.append("perno", args.selectedPerno || "");
      this.$store
        .dispatch("GetVacationDetailForPerson", { params })
        .then((result) => {
          if (result.type == "success") {
            if (result.data.length > 0) {
              this.vacationDetails = result.data[0];
              this.vacationDetails.Year = args.Year;
              this.ShowVacationDetailForEdit(this.vacationDetails);
            }
          }
        });
    },
    ShowVacationDetailForEdit(vacationDetails) {
      this.vacationParams.PageNo = vacationDetails.PageNo.trim();
      this.vacationParams.Description = vacationDetails.UserDescription;

      let vacationType = this.vacationTypes.find(
        (item) => item.Code == vacationDetails.Type
      );
      if (vacationType) {
        this.changeVacationType(vacationType);
      }

      this.initBeginDate = this.beginDate =
        vacationDetails.Year + "/" + vacationDetails.BeginDate;
      this.initEndDate = this.endDate =
        vacationDetails.Year + "/" + vacationDetails.EndDate;
      if (vacationDetails.IsDaily === false) {
        this.initBeginTime = this.beginTime = vacationDetails.BeginTime;
        this.initEndTime = this.endTime = vacationDetails.EndTime;
      }
    },
    bDate(date) {
      debugger
      this.beginDate = date;
      if(this.vacationParams.vacationType.IsDaily==0){
        this.initEndDate =date;
      } 
    },
    eDate(date) {
      debugger
      this.endDate = date;
    },
    bTime(date) {
      this.beginTime = date;
    },
    eTime(date) {
      this.endTime = date;
      
    },
    getVacationTypes() {
      this.$store.dispatch("GetWebVacationTypeList").then((response) => {
        if (response.type === "success") {
          this.vacationTypes = response.data;
          if (this.vacationTypes.length > 0) {
            this.vacationParams.vacationType = this.vacationTypes[0];
            this.showVacationTime = this.vacationTypes[0].IsDaily == 0;

            this.getArgs();
          }
        }
      });
    },
    changeVacationType(item) {
      console.log(item);
      debugger
      this.IntervalIOListVisibility = false;
      this.vacationParams.vacationType = item;
      if (item.IsDaily == 0) {
        this.showVacationTime = true;
        this.visibleBtn=true;
        this.getArgs()
        this.initEndDate=this.beginDate
      }
      else {
        this.showVacationTime = false;
        this.visibleBtn=false;
      }
      // if(item.Code==2){
      //   this.visibleBtn=true;
      //   this.getArgs()
      //   this.initEndDate=this.beginDate
      // }
      // else{
      //   this.visibleBtn=false;
      // } 

    },
    addVacation() {
      debugger
      this.showDialogProgress = true;
      if (!this.beginDate || !this.endDate) {
        var aa= this.endDate;
        var bb= this.beginDate;
        console.log('aa:'+aa+'bb:'+bb)
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.wrongDate"),
        });
        this.showDialogProgress = false;
        return;
      }

      //dateMustbeinSameYear
      if (this.beginDate.substr(0, 4) != this.endDate.substr(0, 4)) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.dateMustbeinSameYear"),
        });
        this.showDialogProgress = false;
        return;
      }

      //CompareDates
      if (DateUtils.CompareDates(this.beginDate, this.endDate) != 1) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.CompareDates"),
        });
        this.showDialogProgress = false;
        return;
      }

      //hourly
      if (this.vacationParams.vacationType.IsDaily == 0) {
        //empty time
        if (!this.beginTime || !this.endTime) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("eosWinKartWebResource.wrongTime"),
          });
          this.showDialogProgress = false;
          return;
        }

        //CompareTimes
        if (
          this.beginDate + " " + this.beginTime >=
          this.endDate + " " + this.endTime
        ) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("eosWinKartWebResource.CompareTimes"),
          });
          this.showDialogProgress = false;
          return;
        }

        if (this.beginDate == this.endDate) {
          if (this.beginTime >= this.endTime) {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: this.$t("eosWinKartWebResource.CompareTimes"),
            });
            this.showDialogProgress = false;
            return;
          }
        }

        /**todo:
         * if (Vacation.IsOrdinaryVacation(int.Parse(ddlVacationList.SelectedItem.Value)))
                {
                    if (Vacation.HourlyVacationsOverflowed(perno, txtbeginDate.Text.Trim(), txtbeginDate.Text.Trim(),
                                                                        txtBeginTime.Text.Trim(),
                                                                        txtEndDate.Text.Trim(),
                                                                        txtEndTime.Text.Trim(), _pageno))
                    {
                        lblError.Text = Properties.eosWinKartWebResource.IsMorThanHourlyVacationPerYearLimitation;
                        return;
                    }
                }
         */

        //over 24 hours
        var moment = require("jalali-moment");
        var a = moment(
          this.beginDate + "-" + this.beginTime,
          "jYYYY/jMM/jDD-hh:mm"
        ).locale("fa");

        var b = moment(
          this.endDate + "-" + this.endTime,
          "jYYYY/jMM/jDD-hh:mm"
        ).locale("fa");

        var diff = b.diff(a, "hours");
        if (diff > 24) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: "مدت زمان مرخصی ساعتی بیش از 24 ساعت است",
          });
          return;
        }
      } else {
        this.beginTime = "00:00";
        this.endTime = "23:59";

        //
        if (
          this.beginDate == this.endDate &&
          this.beginTime &&
          this.endTime &&
          this.beginTime === this.endTime
        ) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: "ساعت شروع و پایان مرخصی در یک روز، یکسان درج شده است",
          });
          this.showDialogProgress = false;
          return;
        }
      }

      const params = new URLSearchParams();
      params.append("BeginDate", this.beginDate);
      params.append("EndDate", this.endDate);
      params.append("BeginTime", this.beginTime);
      params.append("EndTime", this.endTime);
      params.append("Description", this.vacationParams.Description || "");
      params.append("VacationType", this.vacationParams.vacationType.Code);
      params.append("PageNo", this.vacationParams.PageNo || "");
debugger;
      this.$store.dispatch("AddVacation", { params }).then((result) => {
        if (result.type === "success") {
          this.$EosToast.show({
            type: EosToastType.success,
            msg: this.$t("msg-registration-success", {
              opName: this.$t("nav-request-leave"),
            }),
          });
          this.showDialogProgress = false;

          if (this.vacationParams.PageNo && this.args && this.args.from) {
            this.$router.push({ name: this.args.from });
          }
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || "error",
          });
          this.showDialogProgress = false;
        }
      });
     
    },
    gotoIntervalIo(){
      this.$router.push({ name: "interval-io" });

    },
    showIntervalIo(){
      this.IntervalIOListVisibility = true;
      this.$refs.intervalIOList.showIntervalDays(2, this.beginDate);
      // if (this.IntervalIOListVisibility == false) {
      //   this.$refs.intervalIOList.showIntervalDays(2, this.beginDate);
      // }
      // this.IntervalIOListVisibility = !this.IntervalIOListVisibility;
      // this.IntervalIOListVisibility = true;
    },
    checkDescriptionRules() {
      var IsCommentRequired =
        this.$store.state.settings.settings.IsCommentRequiredForVacation;
      if (IsCommentRequired == 1) {
        this.$refs.description.rules = [this.$rules.required];
      }
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  max-width: 80px;
}
</style>